<template>
  <v-dialog v-model="is_SendTypeModal" max-width="500px">
    <v-card class="sendtype-setting">
      <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">발송 타입 설정</v-card-title>
      <v-card-text class="pl-5 pb-0">{{ isAllowedKakao ? "카톡+" : "" }}SMS+메일 발송 타입을 설정해주세요.</v-card-text>
      <v-card-text>
        <v-radio-group v-model="sendingType" col hide-details class="mt-4 text-mid">
          <v-radio v-if="isAllowedKakao" class="mb-4" label="카카오톡 + SMS + 메일 발송" value="kakao_sms_email"></v-radio>
          <v-radio
            v-if="isAllowedKakao"
            class="mb-4"
            label="카카오톡 + 메일 발송 (카카오톡 발송 실패시 SMS 발송 처리)"
            value="kakao_email"
          ></v-radio>
          <v-radio v-if="isAllowedKakao" class="mb-4" label="카카오톡 발송 (카카오톡 발송 실패시 SMS 발송 처리)" value="kakao"></v-radio>
          <v-radio class="mb-4" label="SMS + 메일 발송" value="sms_email"></v-radio>
          <v-radio class="mb-4" label="SMS 발송" value="sms"></v-radio>
          <v-radio class="mb-4" label="메일 발송" value="email"></v-radio>
        </v-radio-group>
        <v-card-actions class="d-flex justify-space-between mt-3 px-0 pb-0">
          <div style="width:220px;">
            <v-btn color="grey darken-4" block class="white--text" @click="is_SendTypeModal = false">닫기</v-btn>
          </div>
          <div style="width:220px;">
            <v-btn color="blue darken-1" block class="white--text" @click="changeSendType">설정하기</v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
.sendtype-setting .v-radio label {
  font-size: 15px;
  color: black !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      is_SendTypeModal: false,
      sendingType: "",
    };
  },
  mixins: [CommonMixin],
  computed: {
    isAllowedKakao() {
      return this.isAllowedKakaoForDigital();
    },
  },
  methods: {
    openSendTypeModal(setting) {
      this.is_SendTypeModal = setting.open;
      if (setting.sendType) {
        this.sendingType = setting.sendType;
      } else {
        this.sendingType = "";
      }
    },
    changeSendType: async function() {
      // API Call Put
      const res = M.api(M.entry("/put/config/message/send_type"), {
        sending_type: this.sendingType,
      });
      if (res) {
        // 저장 성공/실패 여부 처리
        this.alertShow("발송 타입 설정이 저장되었습니다.");
        this.$emit("save", this.sendingType);
        this.is_SendTypeModal = false;
      }
    },
  },
  filters: Filters,
};
</script>
